import PropTypes from 'prop-types'

import {BASE_CLASS, IFRAME_PERMISSIONS} from './config.js'

const IFRAME_CLASS = `${BASE_CLASS}Frame`
const YoutubeIframe = ({videoURL, title}) => (
  <iframe className={IFRAME_CLASS} src={videoURL} title={title} allow={IFRAME_PERMISSIONS}></iframe>
)

export default YoutubeIframe

YoutubeIframe.propTypes = {
  videoURL: PropTypes.string,
  title: PropTypes.string
}
